import { render, staticRenderFns } from "./ObservationsPrintReportPhotosPage.vue?vue&type=template&id=6a879789&"
import script from "./ObservationsPrintReportPhotosPage.vue?vue&type=script&lang=js&"
export * from "./ObservationsPrintReportPhotosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports